<!--  -->
<template>
  <div>
    <div class="content">
        <div class="list" v-for="listItem in totalList">
            <div class="left">
                <img v-if="listItem.typename == '知识产权强企赋能'" src="../../assets/img/img-photo1.png" alt="">
                <img v-if="listItem.typename == '质量品牌强企赋能'" src="../../assets/img/img-photo2.png" alt="">                
                <img v-if="listItem.typename == '标准化创新强企赋能'" src="../../assets/img/img-photo3.png" alt="">
                <img v-if="listItem.typename == '技术平台助企赋能'" src="../../assets/img/img-photo4.png" alt="">
                <img v-if="listItem.typename == '治理结构强企赋能'" src="../../assets/img/img-photo5.png" alt="">
                <img v-if="listItem.typename == '竞争政策助企赋能'" src="../../assets/img/img-photo6.png" alt="">
            </div>
            <div class="right">
                <div class="item" v-for="(item, index) in listItem.marketsupervisionServices" :key="item.type">
                    <div class="title">
                        <div class="num">{{ (index<10 ? '0'+ (index+1) : (index+ 1)) }}</div>
                        <div class="title-desc">{{ item.title }}</div>
                    </div>
                    <div class="direction">{{ item.synopsis }}</div>
                    <div class="info">
                        <div class="info-info">
                            <div style="display: flex; align-items: center;">
                                <img src="../../assets/img/imgPages-icon.png" alt="">
                                <div class="desc">联系科室(单位): </div>
                            </div>
                            <div class="desc-desc">{{ item.contactUnit }}</div>
                        </div>
                        <div class="info-info">
                            <div style="display: flex; align-items: center;">
                                <img src="../../assets/img/imgPages-icon.png" alt="">
                                <div class="desc">联系人及联系方式: </div>
                            </div>
                            <div class="desc-desc" v-for="contactItem in item.contacts.split('，')">{{ contactItem }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { Server, httpurl } from '@/server';
export default {
  data () {
    return {
        totalList: [], // 全部列表
        zhishichanquanList: [],
        downloadUrl: ''
    }
  },
  created() {
    this.getData()
    this.downloadUrl = this.$downloadUrl
  },
  methods: {
    getData() {
        Server.getImgServiceInfo().then(res => {
            console.log(res);
            this.totalList = res.result
            console.log(this.zhishichanquanList);
            
        })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
    margin: 30px 0 50px;
    padding: 20px 30px;
    box-sizing: border-box;
    background-color: #fff;
    .list {
        display: flex;
        margin-bottom: 10px;
        .left {
            width: 200px;
            height: 100px;
            margin-right: 30px;
        }
        .right {
            flex: 1;
            .item {
                margin-bottom: 20px;
                .title {
                    background-color: #027BFF;
                    color: #fff;

                    display: flex;
                    padding: 5px 0;
                    .num {
                        padding: 0 10px;
                    }
                    .title-title {
                        letter-spacing: 1px;
                    }
                }
                .direction {
                    margin-left: 10px;
                    margin-top: 5px;
                    font-size: 14px;
                    line-height: 25px;
                    color: #010101;
                }
                .info {
                    margin-top: 10px;
                    .info-info {
                        // display: flex;
                        // align-items: center;
                        img {
                            width: 15px;
                            height: 15px;
                            margin-right: 10px;
                        }
                        .desc {
                            color: #027BFF;
                            font-weight: bold;
                        }
                        .desc-desc {
                            color: #000;
                            font-weight: bold;
                            margin: 10px 0;
                        }
                    }
                }
            }
        }
    }
}

</style>
